(() => {
  if (window.EE_SCORE_CAMPAIGN_LOADED) return;
  window.EE_SCORE_CAMPAIGN_LOADED = true;

  const pad2 = (value) => String(Math.max(0, value)).padStart(2, "0");

  function updateCountdowns() {
    document.querySelectorAll("[data-ee-kickoff]").forEach((root) => {
      const target = new Date(root.dataset.eeKickoff || "").getTime();
      if (!Number.isFinite(target)) return;
      const remaining = Math.max(0, target - Date.now());
      const values = {
        days: Math.floor(remaining / 86400000),
        hours: Math.floor((remaining / 3600000) % 24),
        minutes: Math.floor((remaining / 60000) % 60),
        seconds: Math.floor((remaining / 1000) % 60),
      };
      Object.keys(values).forEach((key) => {
        root.querySelectorAll(`[data-ee-${key}]`).forEach((el) => {
          el.textContent = pad2(values[key]);
        });
      });
    });
  }

  function updatePredictionSummary(form) {
    if (!form) return;
    const teamA = form.dataset.teamA || form.querySelector("[data-ee-team-a-name]")?.value || "Team A";
    const teamB = form.dataset.teamB || form.querySelector("[data-ee-team-b-name]")?.value || "Team B";
    const a = form.querySelector("[data-ee-score-a]")?.value || "0";
    const b = form.querySelector("[data-ee-score-b]")?.value || "0";
    const email = form.querySelector('input[type="email"]')?.value || "";
    const summary = `${teamA} ${a} : ${b} ${teamB}${email ? ` | Email: ${email}` : ""}`;
    form.querySelectorAll("[data-ee-prediction-summary]").forEach((input) => {
      input.value = summary;
    });
    form.querySelectorAll("[data-ee-prediction-score-text]").forEach((el) => {
      el.textContent = `${teamA} ${a} : ${b} ${teamB}`;
    });
  }

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-ee-score-step]");
    if (!button) return;
    const form = button.closest(".ee-prediction-form, [data-ee-prediction-form]");
    const input = form?.querySelector(`[data-ee-score-${button.dataset.eeTarget}]`);
    if (!input) return;
    const step = Number(button.dataset.eeStep || 0);
    const min = Number(input.min || 0);
    const max = Number(input.max || 20);
    const next = Math.min(max, Math.max(min, Number(input.value || 0) + step));
    input.value = next;
    updatePredictionSummary(form);
  });

  document.addEventListener("input", (event) => {
    const form = event.target.closest?.(".ee-prediction-form, [data-ee-prediction-form]");
    if (form) updatePredictionSummary(form);
  });

  document.addEventListener("submit", (event) => {
    const form = event.target.closest?.(".ee-prediction-form, [data-ee-prediction-form]");
    if (form) updatePredictionSummary(form);
  }, true);

  updateCountdowns();
  document.querySelectorAll(".ee-prediction-form, [data-ee-prediction-form]").forEach(updatePredictionSummary);
  setInterval(updateCountdowns, 1000);
})();
